var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rebates-summary-container"},[_c('div',{staticClass:"vx-card vs-con-loading__container",attrs:{"id":"grid-loader"}},[_c('SharedList',{attrs:{"source":_vm.source,"sharedListData":_vm.sharedListData}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }